<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('segmento-fundamental-i')" class="main mb-5" id="about-main">
      <b-container fluid="lg">
        <b-card no-body class="shadow-sm card_sistemacpv p-4">
          <div @click="isToggleCadernoIII" variant="transparent" class="border border-light bg-light rounded-top p-3">
            <div class="clearfix">
              <div class="float-left">
                <h5><span class="font-weight-light">3º Bimestre</span></h5>
              </div>
              <div class="float-right">
                <i class="fa-solid fa-minus" v-if="isCadernoIIICollapsed" style="color: #e98b24"></i>
                <i class="fa-solid fa-plus" v-else style="color: #e98b24"></i>
              </div>
            </div>
          </div>
          <b-collapse v-model="isCadernoIIICollapsed" id="accordion-1" class="border border-light rounded-bottom">
            <div class="p-3">
              <b-row>
                <b-col cols="12" md="4" lg="3" v-for="(list, index) in lists.data.bimestre3" :key="index">
                  <b-card no-body class="mb-3" :img-src="list.src" img-alt="Image" img-top>
                    <div v-if="list.videoId">
                      <youtube :video-id="list.videoId" player-width="100%" player-height="175px"
                        onload="iFrameResize" />
                    </div>
                    <!-- <div class="p-3">
                      <h6 class="text-center two-colors">{{ list.title }}</h6>
                      <hr />
                      <p v-if="list.isbn !== ''" class="text-center">{{ list.isbn }}</p>
                    </div> -->
                  </b-card>
                </b-col>
              </b-row>
            </div>
          </b-collapse>


          <b-row class="mt-4">
            <b-col cols="12">
              <div class="d-flex justify-content-center">
                <b-button href="http://www.letras.com.br/musicas-infantis" class="btn btn_sistemacpv"
                  variant="transparent" target="_blank">
                  <i class="fa-regular fa-music"></i>
                  <span style="font-size: 14px">Confira outras sugestões.</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getIdFromURL } from 'vue-youtube-embed';

export default {
  data() {
    return {
      NamePermission: '',
      pageTitle: 'ENSINO FUNDAMENTAL I',
      pageSubtitle: 'Músicas & Vídeos - 3º ANO',
      IndexPermission: '',
      lists: {
        data: {
          bimestre1: [
            {
              name: 'Língua Portuguesa',
              page: '84',
              musica_name: 'Pintinho Amarelinho',
              link_url: 'https://www.youtube.com/watch?list=SROs%20dedinhos&v=YXlxFH7MCac',
              videoId: getIdFromURL('https://youtu.be/a8v1c79H3NA?t=7'),
            },
            {
              name: 'Geografia',
              page: '134',
              musica_name: 'A Casa',
              link_url: 'https://www.youtube.com/watch?v=Nwt91MpnOHE',
              videoId: getIdFromURL('https://youtu.be/Nwt91MpnOHE'),
            },
            {
              name: 'Geografia',
              page: '144',
              musica_name: 'Quem Tem Medo do Lobo Mau',
              link_url: 'https://www.youtube.com/watch?v=pMLWWiBvWX8',
              videoId: getIdFromURL('https://youtu.be/pMLWWiBvWX8'),
            },
            {
              name: 'Ciências',
              page: '262',
              musica_name: 'Os Sentidos',
              link_url: 'https://www.youtube.com/watch?v=-hp_pQk5Pak',
              videoId: getIdFromURL('https://youtu.be/-hp_pQk5Pak'),
            },
          ],
          bimestre2: [
            {
              name: 'Língua Portuguesa',
              page: '',
              musica_name: 'Tem francesa no morro',
              link_url: 'https://www.youtube.com/watch?v=PKa9LSsJhXo',
              videoId: getIdFromURL('https://www.youtube.com/embed/v=PKa9LSsJhXo'),
            },
          ],
          bimestre3: [
            {
              name: 'História',
              page: '124',
              musica_name: 'Lindo balão azul',
              link_url: 'https://www.youtube.com/watch?v=CuunfAjpARY',
              videoId: getIdFromURL('https://www.youtube.com/embed/v=CuunfAjpARY'),
            },
          ],
          bimestre4: [
            {
              name: 'Geografia',
              page: '',
              musica_name: 'Brincando de Indio',
              link_url: 'https://www.youtube.com/watch?v=2v5n7Q8oK0Q',
              videoId: getIdFromURL('https://www.youtube.com/embed/v=2v5n7Q8oK0Q'),
            },
            {
              name: 'Geografia',
              page: '',
              musica_name: 'Dez Indiozinhos',
              link_url: 'https://www.youtube.com/watch?v=QQpX0S4pxMs',
              videoId: getIdFromURL('https://www.youtube.com/embed/v=QQpX0S4pxMs'),
            },
            {
              name: 'Ciências',
              page: '',
              musica_name: 'Banho é Bom',
              link_url: 'https://www.youtube.com/watch?v=IM7Ki0-Mh7M',
              videoId: getIdFromURL('https://www.youtube.com/embed/v=IM7Ki0-Mh7M'),
            },
          ],
        },
      },
      isCadernoICollapsed: false,
      isCadernoIICollapsed: false,
      isCadernoIIICollapsed: true,
      isCadernoIVCollapsed: false,
    };
  },
  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    });
  },
  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return 'Você não tem permissão para visualizar este conteúdo.';
    },
  },
  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    isToggleCadernoI() {
      this.isCadernoICollapsed = !this.isCadernoICollapsed;
      this.isCadernoIICollapsed = false;
      this.isCadernoIIICollapsed = false;
      this.isCadernoIVCollapsed = false;
    },
    isToggleCadernoII() {
      this.isCadernoIICollapsed = !this.isCadernoIICollapsed;
      this.isCadernoICollapsed = false;
      this.isCadernoIIICollapsed = false;
      this.isCadernoIVCollapsed = false;
    },
    isToggleCadernoIII() {
      this.isCadernoIIICollapsed = !this.isCadernoIIICollapsed;
      this.isCadernoICollapsed = false;
      this.isCadernoIICollapsed = false;
      this.isCadernoIVCollapsed = false;
    },
    isToggleCadernoIV() {
      this.isCadernoIVCollapsed = !this.isCadernoIVCollapsed;
      this.isCadernoICollapsed = false;
      this.isCadernoIICollapsed = false;
      this.isCadernoIIICollapsed = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* @import url(../../../../assets/sass/exclusiveContent.scss); */

.card_sistemacpv {
  border-radius: 8px;
  color: #3A1C53;
}

.btn_sistemacpv {
  display: inline-flex;
  min-width: auto;
  min-height: auto;

  margin: 20px auto 0;
  padding: 8px 16px;

  gap: 6px;

  background-color: #e98b24;
  border: 1px solid #e98b24;
  border-radius: 5px;

  display: flex;
  align-items: center;

  font-size: 16px;
  line-height: 22px;

  color: #fdf3e9;

  .icon {
    width: 18px;
    height: 18px;

    display: flex;
    align-items: center;

    i {
      font-size: 16px;
      line-height: 22px;
    }
  }

  &:hover {
    background-color: #d27d20;
    transition: all 0.3s ease-in-out;
    border: 1px solid #d27d20;
    color: #fdf3e9;
  }
}
</style>
